import queryString from "query-string";

import {
    GET_TRAINING_METHOD
} from "@/api/master-data/training-method/training-method";

const state = {
    trainingMethod: [],
};

const mutations = {
    setTrainingMethod: (states, payload) => {
        states.trainingMethod = payload;
    },
};

const actions = {
    getTrainingMethod: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GET_TRAINING_METHOD(params);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setTrainingMethod", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setTrainingMethod", []);
            }
            throw err;
        }
    },
};

const getters = {
    TrainingMethod: (states) => states.trainingMethod,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};